if (window && !(window as any).Intl) {
  // Need @ts-ignore below here since we don't have "dynamic import" options
  // turned on to support the modern Promise-based import() approach.
  //
  // Regardless, require() will always work thanks to webpack.
  // @ts-ignore
  (window as any).Intl = require('intl'); // eslint-disable-line global-require
}
